import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'
import mask from '@alpinejs/mask'
import validation from 'alpinejs-form-validation'

Alpine.plugin(collapse)
Alpine.plugin(mask)
Alpine.plugin(validation)

import './alpine/navigation'
import './alpine/donation-form'
import './alpine/contact-agreement'
import './alpine/carousel'
import './alpine/registration-form'
import './alpine/pdf-generation-form'
import '../web-components/components.js'

window.Alpine = Alpine

Alpine.start()
